export { Theme };

const Theme = new class {
  // localStorageValues : [String]
  //
  // All known theme identifiers.
  localStorageValues = [
    "light",
    "dark"
  ];

  // lightValue, darkValue : String
  //
  // String identifiers for light and dark theme.
  lightValue = this.localStorageValues[0];
  darkValue = this.localStorageValues[1];

  // defaultValue : String
  //
  // The default theme.
  defaultValue = this.lightValue;

  // localStorageKey : String
  //
  // The key in the session storage whose value is the preferred theme.
  localStorageKey = "site-theme";

  // getStored : String | null
  //
  // Get the current value of `localStorageKey` from the session storage.
  getStored() {
    const storedTheme = localStorage.getItem(this.localStorageKey);
    if (this.localStorageValues.includes(storedTheme) || storedTheme === null) {
      return storedTheme;
    } else {
      console.log("unknown theme identifier \"" + storedTheme + "\"");
      return null;
    }
  }

  // setStored : String -> ()
  //
  // `setStored value` sets the value of `localStorageKey` in the session
  // storage to `value`.
  setStored(value) {
    if (this.localStorageValues.includes(value)) {
      localStorage.setItem(this.localStorageKey, value);
    } else {
      console.log("unknown theme identifier \"" + value + "\"");
    }
  }

  // getBrowserPreferredOrElseDefaultTheme : String
  //
  // Return the browser-preferred theme. If this fails, return the default
  // theme.
  getBrowserPreferredOrElseDefaultTheme() {
    if (window.matchMedia("(prefers-color-scheme: light)").matches) {
      return this.lightValue;
    } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return this.darkValue;
    } else {
      return this.defaultValue;
    }
  }

  // init : String
  //
  // Initialize the theme: If there is a theme saved in the session
  // storage, return it. Otherwise return the browser-preferred theme. If this
  // fails, return the default theme.
  init() {
    let storedTheme = this.getStored();
    if (storedTheme === null) {
      return this.getBrowserPreferredOrElseDefaultTheme();
    } else {
      return storedTheme;
    }
  }

  // getCurrent : String
  //
  // Get the theme of the current document (via the `data-site-theme` attribute of
  // the `html` tag).
  getCurrent() {
    let theme = document.documentElement.getAttribute("data-site-theme");
    switch (theme) {
      case "light":
        return this.lightValue;
      case "dark":
        return this.darkValue;
      default:
        console.log("unknown theme \"" + theme + "\"");
        return null;
    }
  }

  // setCurrent : String -> ()
  //
  // Set the theme of the current document (via the `data-site-theme` attribute of
  // the `html` tag).
  setCurrent(theme) {
    switch (theme) {
      case this.lightValue:
        document.documentElement.setAttribute("data-site-theme", "light");
        break;
      case this.darkValue:
        document.documentElement.setAttribute("data-site-theme", "dark");
        break;
      default:
        console.log("unknown theme \"" + theme + "\"");
    }
  }
};
